export default "__VITE_ASSET__633d2192__"